import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const TrackerDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="tracker-button"
        aria-controls={open ? "tracker-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="inherit"
        endIcon={<ArrowDropDownIcon />}
      >
        Tracker
      </Button>
      <Menu
        id="tracker-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "tracker-button",
        }}
      >
        <MenuItem onClick={handleClose} component={Link} to="/live-tracking">
          Live Tracking
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/all-trackers">
          All trackers
        </MenuItem>
      </Menu>
    </div>
  );
};

export default TrackerDropdown;
